import authActions from "./authActions";
import chatActions from "./chatActions";
import notificationActions from "./notificationActions";
import serviceActions from "./serviceActions";
import userActions from "./userActions";
import commissionActions from "./commissionActions";
import paymentActions from "./paymentActions";
import orderActions from "./orderActions";
import alertActions from "./alertActions";
import logActions from "./logActions";
import parameterActions from "./parameterActions";
import ratingActions from "./ratingActions";
import componentsActions from "./componentsActions";
import tasksActions from "./tasksActions";
import reportActions from "./reportActions";
import downloadActions from "./downloadActions";
import processActions from "./processActions";
import newsActions from "./newsActions";
import DODActions from "./DODActions";
import leftBarElementsActions from "./leftBarElementsActions";
import dodCustomersActions from "./dodCustomersActions";
import dodEmployeesActions from "./dodEmployeesActions";
import dodTasksActions from "./dodTasksActions";
import dodSmsActions from "./dodSmsActions";
import dodSettingsActions from "./dodSettingsActions";
import dodFilesActions from "./dodFilesActions";
import dodUsersActions from "./dodUsersActions";
import dodAdminsActions from "./dodAdminsActions";
import dodOrdersActions from "./dodOrdersActions"
import dodMessagesActions from "./dodMessagesActions";
import dodSettlementsActions from "./dodSettlementsActions";
import dodReportArchiveActions from "./dodReportArchiveActions";
export default {
  ...authActions,
  ...chatActions,
  ...notificationActions,
  ...serviceActions,
  ...userActions,
  ...commissionActions,
  ...paymentActions,
  ...orderActions,
  ...alertActions,
  ...logActions,
  ...parameterActions,
  ...ratingActions,
  ...componentsActions,
  ...tasksActions,
  ...reportActions,
  ...downloadActions,
  ...processActions,
  ...newsActions,
  ...DODActions,
  ...leftBarElementsActions,
  ...dodCustomersActions,
  ...dodEmployeesActions,
  ...dodTasksActions,
  ...dodSmsActions,
  ...dodSettingsActions,
  ...dodFilesActions,
  ...dodUsersActions,
  ...dodAdminsActions,
  ...dodOrdersActions,
  ...dodMessagesActions,
  ...dodSettlementsActions,
  ...dodReportArchiveActions,
};
